var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShoePrints(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 0c3 0 7 1.5 7 4s-3.75 3-5.5 3c-1.5 0-2.375-.5-3.25-1S9.5 5 8 5V1s3-1 5-1zM4 3c0-1.094.875-2 2-2h1v4H6c-1.125 0-2-.875-2-2zm5 13c-2 0-5-1-5-1v-4c1.5 0 2.375-.5 3.25-1S9 9 10.5 9c1.75 0 5.5.5 5.5 3s-4 4-7 4zm-9-3c0-1.094.875-2 2-2h1v4H2c-1.125 0-2-.875-2-2z",
    fill: "#161616"
  })));
}
export default SvgShoePrints;